<div class="modal-dialog modal-xl mt-0 mb-0">
    <div class="modal-content" style="min-height: 450px;">
        <div class="modal-body">
            <button type="button" aria-label="Close" (click)="bsModalRef.hide()" class="btn-close btn-danger float-end"
                data-bs-dismiss="modal" aria-label="Close">
            </button>
            <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
                <h4 class="titulo_seccao">Consulta de peça</h4>
            </div>
            <form [formGroup]="resourceForm">

                <div class="card-body">
                    <div class="row d-flex" style="flex-direction: row;">
                        <div class="d-flex" style="width: 210px;">
                            <app-input-field label="Placa" formControlName="placa_auto" [isReadOnly]="isReadOnly"
                                mask="AAAAAAA">
                            </app-input-field>
                        </div>
                        <div class="d-flex" style="margin-top: 1%; width: 95px;
                        height: 55px; margin: auto 0;">
                            <button type="button" (click)="consultaPlaca()"
                                class="btn btn-primary btnDev bg-teal btn-md mt-3" data-toggle="tooltip"
                                data-placement="top" title="Consultar Placa" id="btn_consulta_placa">
                                Consultar
                            </button>
                        </div>
                        <div class="d-flex" style="width: 10px; margin: auto 20px;
                        height: 15px;"><i class="fa fa-info-circle" aria-hidden="true" (click)="alertaConsultaPlaca()"
                                style="font-size: 30px; cursor: pointer;" title="Clique para mais Informações"></i></div>
                    </div>
                    <hr class="hr_div">
                    <div class="row selects_div">
                        <div class="col-3">
                            <app-select-field-search-tag [(ngModel)]="model.marca" [itens]="marcas"
                                (change)="onChangeMarca($event)" label="Marca" formControlName="marca"
                                [isReadOnly]="isReadOnly">
                            </app-select-field-search-tag>
                        </div>
                        <div class="col-3">
                            <app-select-field-search-tag [(ngModel)]="model.geracao" [itens]="geracoes"
                                (change)="onChangeGeracao($event)" label="Geração" formControlName="geracao"
                                [isReadOnly]="isReadOnly">
                            </app-select-field-search-tag>
                        </div>
                        <div class="col-3">
                            <app-select-field-search-tag [(ngModel)]="model.modelo" [itens]="modelos"
                                (change)="onChangeModelo()" label="Modelo" formControlName="modelo"
                                [isReadOnly]="isReadOnly">
                            </app-select-field-search-tag>
                        </div>
                        <div class="col-3">
                            <app-select-field-search [(ngModel)]="model.versao" [itens]="versoes"
                                (change)="onChangeVersao($event)" label="Versao" formControlName="versao"
                                [isReadOnly]="isReadOnly">
                            </app-select-field-search>
                        </div>
                        <div class="col-3">
                            <app-select-field-search [(ngModel)]="model.veiculo" [itens]="veiculos" label="Veiculo"
                                (change)="onChangeVeiculo($event)" formControlName="veiculo" [isReadOnly]="isReadOnly">
                            </app-select-field-search>
                        </div>
                    </div>
                    <div class="div_btns">
                        <button class="btn-open-consulta" (click)="abrirConsultaDePecas()"><i class="fa fa-search"></i> Consultar Peças</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
